import React from 'react';
import { AnimatedSection } from './AnimatedSection';
export function TruthSection() {
  return <section className="py-20 px-6 md:px-8 max-w-2xl mx-auto" data-id="element-201">
      <AnimatedSection data-id="element-202">
        <h2 className="text-3xl md:text-4xl font-serif text-bark mb-8 text-center" data-id="element-203">
          La verdad (sin azúcar)
        </h2>

        <div className="space-y-6 text-lg text-bark/90 leading-relaxed" data-id="element-204">
          <p data-id="element-205">La mayoría de los planes espirituales fallan por una razón:</p>

          <p className="text-2xl font-serif font-bold text-wine text-center py-4" data-id="element-206">
            están diseñados para una vida que no tenés.
          </p>

          <p data-id="element-207">Te piden tiempo “limpio”. Silencio. Energía.</p>
          <p data-id="element-208">Como si la vida fuese a darte permiso.</p>
          <p data-id="element-209">
            Entonces te esforzás, te exigís… y cuando no sostenés, te castigás.
          </p>
          <p data-id="element-210">
            Y ahí se rompe la relación con la oración, porque la convertís en
            examen.
          </p>
        </div>
      </AnimatedSection>
    </section>;
}